import { BookingType } from '@ibe.models/booked-trip.model.lib';
import { Duration } from '@ibe.models/duration.model';
import { Airport } from '@ibe/models';

export class SearchParameters {
	from: any;
	to: {type: 'region' | 'country' | 'multiple' | 'anywhere', label: string, selected: Array<any>};
	type: BookingType;
	duration: {from: Duration, to: Duration};
	budget: any;
	theme: Array<string>;

	constructor() {
		this.from = '';
		this.to = {type: null, label: '', selected: []};
		this.type = 'R';
		this.duration = null;
		this.budget = '';
		this.theme = null;
	}

	// constructor() {
	// 	this.from = '';
	// 	this.to = { type: 'anywhere', label: 'Anywhere', selected: [] };
	// 	this.type = 'round trip';
	// 	this.duration = {
	// 		from: {
	// 			selection: { value: "", label: "Anytime" },
	// 			type: "anytime"
	// 		},
	// 		to: {
	// 			selection: { value: "", label: "Anytime" },
	// 			type: "anytime"
	// 		}
	// 	}
	// 	this.budget = 6; // 'Any price'
	// 	this.theme = null;
	// }
}

export class Offer {
	destination: { name: string; image: string; country: string; theme: Array<string>; airports: Array<Airport> };
	total: number;
	minPrice: number;
}

/**
 * State of the trip-finder
 *
 * @export
 * @class State
 */
export class State {
	loading: boolean;
	search: SearchParameters;
	offers: Array<Offer>;
	selectedOffer: Offer;
}

export const initialState: State = {
	loading: false,
	search: null,
	offers: null,
	selectedOffer: null
};
